// extracted by mini-css-extract-plugin
export default {"checkbox":"RefundFreeForm_checkbox__YvpN-"};